import { withParams } from "utils/helpfulFunctions";
import {
  postResource,
  getResource,
  putResource,
  deleteResource,
} from "./services";
import store from "../store";

/* Start admin */
export const signinAdmin = (data, onSuccess, onFail) => {
  const path = "api/Admin/Login?lang=en";
  postResource(path, data, onSuccess, onFail);
};
export function getAdminsApi(onSuccess, onFail) {
  const path = "api/Admin/GetScrappersAdmins";
  getResource(path, onSuccess, onFail);
}
export function addAdminApi(data, onSuccess, onFail) {
  const path = "api/Admin/AddAdmin";
  postResource(path, data, onSuccess, onFail);
}
export function editAdmin(data, onSuccess, onFail) {
  const path = `api/Admin/EditAdmin`;
  putResource(path, data, onSuccess, onFail);
}
export function getAdminRoles(onSuccess, onFail) {
  const path = "api/Admin/GetBigScrappersRoles";
  getResource(path, onSuccess, onFail);
}
export function checkAdminStatus(onSuccess, onFail) {
  const path = "api/Admin/CheckAdminStatus";
  getResource(path, onSuccess, onFail);
}
/* End admin */

/* Start dealers */
export function getDealersApi(params, onSuccess, onFail) {
  // const path = "api/User/GetScraptionUsers";
  const path = `api/User/GetScraptionUsersV2?perPage=${
    params.perPage
  }&pageNumber=${params.currentPage}&fullName=${params.fullName}&mobile=${
    params.mobile
  }&isMerchant=${params.isMerchant}&deservedAmount=${
    params.deservedAmount
  }&isExport=${params.isExport || false}`;
  getResource(path, onSuccess, onFail);
}
export function getDealerBalanceApi(dealerId, onSuccess, onFail) {
  const path = `api/Dealer/DealerBalanceForAdmin?dealerId=${dealerId}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function getStoreBalances(onSuccess, onFail) {
  const path = `api/Dealer/GetStoreBalances?language=ar`;
  getResource(path, onSuccess, onFail);
}
export function updateMerchantStatusOfScrapper(data, onSuccess, onFail) {
  const path = `api/Dealer/UpdateDealerIsMerchant?language=en`;
  putResource(path, data, onSuccess, onFail);
}
export function getOldPendingOrders(noOfDays, onSuccess, onFail) {
  const path = `api/Dealer/GetOldPendingOrders?noOfDays=${noOfDays}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function getInactiveCustomers(noOfDays, onSuccess, onFail) {
  const path = `api/Dealer/GetInactiveCustomers?noOfDays=${noOfDays}&language=en`;
  getResource(path, onSuccess, onFail);
}
/* End dealers */

/* Start items */
export const addItemApi = (data, onSuccess, onFail) => {
  const path = "api/Item/ScraptionItem?lang=en";
  postResource(path, data, onSuccess, onFail);
};
export const editItemApi = (data, onSuccess, onFail) => {
  const path = "api/Item/ScraptionItem?lang=en";
  putResource(path, data, onSuccess, onFail);
};
export const deleteItemApi = ({ itemId }, onSuccess, onFail) => {
  const path = `api/Item/ScraptionItem?lang=en&itemId=${itemId}`;
  deleteResource(path, onSuccess, onFail);
};
export function getAllUnitsApi(onSuccess, onFail) {
  const path = "api/Item/Units?language=en";
  getResource(path, onSuccess, onFail);
}
export function getAllItemsApi(onSuccess, onFail) {
  const path = "api/Item/ScraptionItemsForAdmin?lang=en";
  getResource(path, onSuccess, onFail);
}
/* End items */

/* Start orders */
export function getPendingOrdersForAdminApi(onSuccess, onFail) {
  const path = "api/Order/GetScraptionPendingOrdersForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function acceptRejectPendingOrderByAdminApi(data, onSuccess, onFail) {
  const path = "api/Admin/AcceptOrRejectPendingOrderByAdmin?lang=en";
  postResource(path, data, onSuccess, onFail);
}
export function getOrders(onSuccess, onFail) {
  const path = "api/Order/GetOrdersForScraption?lang=en";
  getResource(path, onSuccess, onFail);
}
export function updateOrderStatusApi(data, onSuccess, onFail) {
  const path = "api/Admin/UpdateOrderStatus?lang=en";
  putResource(path, data, onSuccess, onFail);
}
export function getOrderStatusApi(onSuccess, onFail) {
  const path = "api/User/OrderStatus?language=en";
  getResource(path, onSuccess, onFail);
}
/* End orders */

/* Start category */
export function getCategoriesApi(onSuccess, onFail) {
  const path = "api/Category";
  getResource(path, onSuccess, onFail);
}
export function getActiveCategoriesApi(onSuccess, onFail) {
  const path = "api/Category/GetActiveCategories";
  getResource(path, onSuccess, onFail);
}
/* End category */

/* Start store */
export function getStores(onSuccess, onFail) {
  const path = "api/Admin/StoreForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveStores(onSuccess, onFail) {
  const path = "api/Admin/ActiveStores?language=en";
  getResource(path, onSuccess, onFail);
}
export function addStore(data, onSuccess, onFail) {
  const path = "api/Admin/Store?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editStore(data, onSuccess, onFail) {
  const path = "api/Admin/Store?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function addStoreDistrict(data, onSuccess, onFail) {
  const path = "api/Admin/StoreDistrict?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editStoreDistrict(data, onSuccess, onFail) {
  const path = "api/Admin/StoreDistrict?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function getAddressFromGeolocation(coords, onSuccess, onFail) {
  const LocatioIQToken = encodeURIComponent(
    "pk.ae679be642804939a90eba2f54ffdb9e",
  );
  const path = `https://us1.locationiq.com/v1/reverse?key=${LocatioIQToken}&lat=${coords.lat}&lon=${coords.lng}&format=json`;
  getResource(path, onSuccess, onFail, false, false);
}
/* End store */

/* Start sales requests */
export function getMerchantSalesRequests(onSuccess, onFail) {
  const path = "api/Dealer/SalesRequestForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function AcceptOrRejectMerchantSaleRequest(data, onSuccess, onFail) {
  const path = "api/Dealer/AnswerDealerSaleRequest?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function CollectScraptionBuyAndSupplyOrder(data, onSuccess, onFail) {
  const path = `api/BuyAndSupply/CollectScraptionBuyAndSupplyOrder?id=${data.id}&language=en`;
  postResource(path, data, onSuccess, onFail);
}

/* End sales requests */

/* Start scrappers sales requests */
export function getScrappersSalesRequests(onSuccess, onFail) {
  const path = "api/Dealer/ScrapperSalesRequestForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function AcceptOrRejectScrappersSaleRequest(data, onSuccess, onFail) {
  const path = "api/Dealer/AnswerScrapperSaleRequest?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* End scrappers sales requests */

/* Start Cheques */
export function getChecks(onSuccess, onFail) {
  const path = "api/Check/All";
  getResource(path, onSuccess, onFail);
}

export function addCheck(data, onSuccess, onFail) {
  const path = "api/Check";
  postResource(path, data, onSuccess, onFail);
}
/* End Cheques */

/* Start Settings */
export function getSettings(onSuccess, onFail) {
  const path = "api/Setting/AllScrapperSettings?language=en";
  getResource(path, onSuccess, onFail);
}

export function updateSettings(data, onSuccess, onFail) {
  const path = "api/Setting/ScrapperSetting?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* End Settings */

/* Start Cans Sales Requests */
export function getCansSalesRequests(data, onSuccess, onFail) {
  const path =
    // "api/Dealer/ScrapperCansHistoryWithMultipleTypesForAdmin?language=en";
    // `api/Dealer/ScrapperCansHistoryWithMultipleTypesForAdminV2?language=en&perPage=10&pageNumber=${params.currentPage}&fullName=${params.fullName}&mobile=${params.mobile}&totalPounds=${params.totalPounds}&totalPoints=${params.totalPoints}&totalQuantity=${params.totalQuantity}&pointStatus=${params.pointStatus}&from=${params.from}&to=${params.to}`;
    `api/Dealer/ScrapperCansHistoryWithMultipleTypesForAdminV2?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function getCansSalesRequestsUAE(data, onSuccess, onFail) {
  const path = `api/Dealer/ScrapperCansHistoryWithMultipleTypesForAdminV2UAE?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function AcceptOrRejectCansSalesRequest(data, onSuccess, onFail) {
  const path = "api/Dealer/AcceptOrRejectSalesRequestNew?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getQuantityUnits(onSuccess, onFail) {
  const path = "api/Dealer/UnitTypes?language=en";
  getResource(path, onSuccess, onFail);
}

export function getSupplyingTypesForCansRequest(
  isUAE = false,
  onSuccess,
  onFail,
) {
  if (typeof isUAE === "function") {
    onFail = onSuccess;
    onSuccess = isUAE;
    isUAE = false;
  }
  const path = `api/Dealer/ScrapperSupplyTypes?isUAE=${isUAE}&language=en`;
  getResource(path, onSuccess, onFail);
}

export function addCansSaleRequest(data, onSuccess, onFail) {
  const path = "api/Admin/AddListCansSalesRequestByAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getScrapperSaleRequestInfo(data, onSuccess, onFail) {
  const path = `api/Admin/ScrapperSalesRequestInfo?salesRequestId=${data.salesRequestId}&supplyTypeId=${data.supplyTypeId}&AmountInGrams=${data.AmountInGrams}&language=en`;
  getResource(path, onSuccess, onFail);
}

export function editScrapSalesRequest(data, onSuccess, onFail) {
  const path = "api/Admin/EditScrapSalesRequest?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function addSupplyTypesToCansSalesRequest(data, onSuccess, onFail) {
  const path = "api/Admin/AddListCansSalesRequestSupplyTypeByAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function deleteSupplyTypeFromCansSalesRequest(
  typeId,
  onSuccess,
  onFail,
) {
  const path = `api/Admin/DeleteScrapSalesRequest?language=en&requestId=${typeId}`;
  deleteResource(path, onSuccess, onFail);
}
/* End Cans Sales Requests */

/* Start Accepted Requests Report */
export function getAcceptedRequestsReport(data, onSuccess, onFail) {
  const path = `api/Admin/GetAcceptedScrapSalesRequestV3?language=en`;
  postResource(path, data, onSuccess, onFail);
}
/* Start Accepted Requests Report */

/* Start Redeemed Points requests */
export function getStoreRedeemPointsRequests(data, onSuccess, onFail) {
  // const path = `api/Dealer/StoreRedeemPointsRequestsV2?language=en&perPage=${params.perPage}&pageNumber=${params.pageNumber}&fullName=${params.fullName}&mobile=${params.mobile}&from=${params.from}&to=${params.to}&pounds=${params.pounds}&points=${params.points}&isDelivered=${params.isDelivered}&address=${params.address}&isExport=${params.isExport || false}`;
  const path = "api/Dealer/StoreRedeemPointsRequestsV3?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getStoreRedeemPointsRequestsUAE(data, onSuccess, onFail) {
  const path = "api/Dealer/GetStoreRedeemPointsRequestsv3UAE?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getCashRedeemPointsRequests(onSuccess, onFail) {
  const path = "api/Dealer/CashRedeemPointsRequests?language=en";
  // const path = `api/Dealer/CashRedeemPointsRequestsV2?language=en&perPage=10&pageNumber=${params.currentPage}`;
  getResource(path, onSuccess, onFail);
}

export function MarkStoreRequestAsRedeemed(requestId, onSuccess, onFail) {
  const path = `api/Dealer/SubmitStoreRedeemPoints?redeemId=${requestId}&language=en`;
  postResource(path, {}, onSuccess, onFail);
}

export function MarkCashRequestAsRedeemed(requestId, onSuccess, onFail) {
  const path = `api/Dealer/SubmitCashRedeemPoints?redeemId=${requestId}&language=en`;
  postResource(path, {}, onSuccess, onFail);
}

export function getRedeemOrderStatus(onSuccess, onFail) {
  const path = "api/Admin/GetOrderStatus?language=en";
  getResource(path, onSuccess, onFail);
}

export function changeRedeemOrderStatus(data, onSuccess, onFail) {
  const path = "api/Dealer/ChangeOrderStatus?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function updateRedeemOrderPriceAndAddress(data, onSuccess, onFail) {
  const path = "api/Dealer/AddTotoalPriceAndSavedAddress?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* End Redeemed Points requests */

/* Start Supplying Types */
export function getSupplyingTypes(onSuccess, onFail) {
  const path = "api/ScrapperSupplyType/ForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function addSupplyingType(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function addSupplyingTypeWithImage(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType/WithImage?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editSupplyingType(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function editSupplyingTypeWithImage(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType/WithImage?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function deleteSupplyingType(id, onSuccess, onFail) {
  const path = `api/ScrapperSupplyType?id=${id}&language=en`;
  deleteResource(path, onSuccess, onFail);
}
/* End Supplying Types */

/* start of supplier */

export function addSupplier(data, onSuccess, onFail) {
  const path = "api/Supplier/AddSupplier?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getSuppliersForAdmin(onSuccess, onFail) {
  const path = "api/Supplier/getSuppliersForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function getSuppliersForList(onSuccess, onFail) {
  const path = "api/Supplier/getSuppliersForList?language=en";
  getResource(path, onSuccess, onFail);
}
/* end of supplier */

/* Start Marketplace Banner */
export function getMarketplaceBanners(onSuccess, onFail) {
  const path = "api/Banner/ForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function addMarketplaceBanner(data, onSuccess, onFail) {
  const path = "api/Banner?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editMarketplaceBanner(data, onSuccess, onFail) {
  const path = "api/Banner?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function deleteMarketplaceBanner(id, onSuccess, onFail) {
  const path = `api/Banner?id=${id}&language=en`;
  deleteResource(path, onSuccess, onFail);
}
/* End Marketplace Banner */

/* Start Soical Orders */
export function getSocialOrders(data, onSuccess, onFail) {
  // const path = "api/Dealer/GetSocialOrder?language=en";
  // const path = `api/Dealer/GetSocialOrderV2?language=en`
  // const path = `api/Dealer/GetSocialOrderV3?language=en`;
  const path = `api/Dealer/GetSocialOrderV4?language=en`;
  postResource(path, data, onSuccess, onFail);
}
export function getSocialOrdersUAE(data, onSuccess, onFail) {
  const path = `api/Dealer/GetAllSocialOrdersUAE?language=en`;
  postResource(path, data, onSuccess, onFail);
}
export function getSocialOrderRequestDetailsById(id, onSuccess, onFail) {
  const path = `api/Dealer/GetSocialOrderDetailsByRequestId?RequestId=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function getSocialOrderRequestImagesById(id, onSuccess, onFail) {
  const path = `api/Dealer/GetSocialOrderImagesByRequestId?RequestId=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function getSocialOrderAddressDetailsById(id, onSuccess, onFail) {
  const path = `api/Dealer/GetAddressDetailsByRequestId?RequestId=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function getStoreItemActiveCategories(onSuccess, onFail) {
  const path = "api/Category/StoreItemActiveCategoriesForList?language=en";
  getResource(path, onSuccess, onFail);
}
export function assignOrdersToCourier(data, onSuccess, onFail) {
  const path = "api/Courier/AssignCourier?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editSocialOrderAddress(data, onSuccess, onFail) {
  const path = "api/UserAddress/AddressInfoByAdmin?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function getUserRequestStatus(onSuccess, onFail) {
  const path = "api/Dealer/UserRequestStatus?language=en";
  getResource(path, onSuccess, onFail);
}
export function updateUserRequestStatus(data, onSuccess, onFail) {
  const path = "api/Dealer/SocialUserRequestStatus?language=en";
  putResource(path, data, onSuccess, onFail);
}
// export function getAssignmentStatus(onSuccess, onFail) {
//   const path = "/api/Dealer/AsigningStatus";
//   getResource(path, onSuccess, onFail);
// }
export function updateAssignmentRequestStatus(data, onSuccess, onFail) {
  const path = "api/Dealer/AsigningStatus";
  putResource(path, data, onSuccess, onFail);
}
export function getLogisticTeams(onSuccess, onFail) {
  const path = "api/Dealer/GetLogisticTeam?language=en";
  getResource(path, onSuccess, onFail);
}
export function assignLogisticAdmin(data, onSuccess, onFail) {
  const path = "api/Dealer/AssignLogisticTeam?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function makeRoutesForCourier(data, onSuccess, onFail) {
  const path = "api/Dealer/MakeRoutesForCourier?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function RateOrder(data, onSuccess, onFail) {
  const path = "api/Dealer/EditRating?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function bulkAssignUserStatus(data, onSuccess, onFail) {
  const path = "api/Dealer/ListSocialUserRequestStatus?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function getRequestAssignmentLogs(id, onSuccess, onFail) {
  const path = `api/Courier/RequestCourierAssigningLogs?requestId=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function updateCallCenterStatus(data, onSuccess, onFail) {
  const path = "api/Dealer/CallCenterStatus?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function assignOrdersToDistrict(data, onSuccess, onFail) {
  const path = "api/Courier/AssignDistrict?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Soical Orders */

/* Start Courier */
export function getCourier(onSuccess, onFail) {
  const path = "api/Courier?language=en";
  getResource(path, onSuccess, onFail);
}
export function getMonthlyCourierOrders(id, onSuccess, onFail) {
  const path = `api/Courier/MonthlyCourierOrdersReport?language=en&courierId=${id}`;
  getResource(path, onSuccess, onFail);
}
export function getActiveCouriers(isUAE = false, onSuccess, onFail) {
  if (typeof isUAE === "function") {
    onFail = onSuccess;
    onSuccess = isUAE;
    isUAE = false;
  }
  const path = `api/Courier/CouriersForList?isUAE=${isUAE}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function addCourier(onSuccess, onFail) {
  const path = "api/Courier?language=en";
  postResource(path, onSuccess, onFail);
}
export function editCourier(onSuccess, onFail) {
  const path = "api/Courier?language=en";
  putResource(path, onSuccess, onFail);
}
/* End Courier */

/* Start Courier Report */
export function getCourierReport(data, onSuccess, onFail) {
  // const path = "api/Admin/CourierReport?language=en";
  const path = "api/Admin/CourierReportV2?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getCouriersWhoHaveDailyOrders(data, onSuccess, onFail) {
  const path = `api/Dealer/GetTodayCourierOrders?language=en&from=${data.from}&to=${data.to}`;
  getResource(path, onSuccess, onFail);
}
export function getDailyOrdersForCourier(data, onSuccess, onFail) {
  const path = "api/Dealer/GetTodayCourierOrderDetails?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Courier Report */

/* Start Government */
export function getAllGovernmentsForAdmin(onSuccess, onFail) {
  const path = "api/District/GovernmentsForAdmin";
  getResource(path, onSuccess, onFail);
}
export function getGovernmentsForList(isUAE = false, onSuccess, onFail) {
  if (typeof isUAE === "function") {
    onFail = onSuccess;
    onSuccess = isUAE;
    isUAE = false;
  }
  const path = `api/District/GovernmentsForList?isUAE=${isUAE}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function addGovernment(data, onSuccess, onFail) {
  const path = "api/District/Goverment";
  postResource(path, data, onSuccess, onFail);
}
export function editGovernment(data, onSuccess, onFail) {
  const path = "api/District/Government";
  putResource(path, data, onSuccess, onFail);
}
/* End Government */

/* Start City */
export function getAllCitiesForAdmin(onSuccess, onFail) {
  const path = "api/District/AllDistrictForAdmin";
  getResource(path, onSuccess, onFail);
}
export function getCitiesForList(govenmentId, onSuccess, onFail) {
  const path = `api/District/DistrictsForList?govenmentId=${govenmentId}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function addCity(data, onSuccess, onFail) {
  const path = "api/District";
  postResource(path, data, onSuccess, onFail);
}
export function editCity(data, onSuccess, onFail) {
  const path = "api/District";
  putResource(path, data, onSuccess, onFail);
}
/* End City */

/* Start Zones */
export function getAllZonesForAdmin(onSuccess, onFail) {
  const path = "api/District/ZonesForAdmin";
  getResource(path, onSuccess, onFail);
}

export function getAllDistrictsForAdmin(districtId, onSuccess, onFail) {
  const path = `api/District/DistrictsForList?govenmentId=${districtId}`;
  getResource(path, onSuccess, onFail);
}

export function addZone(data, onSuccess, onFail) {
  const path = "api/District/Zone";
  postResource(path, data, onSuccess, onFail);
}
export function editZone(data, onSuccess, onFail) {
  const path = "api/District/Zone";
  putResource(path, data, onSuccess, onFail);
}

/* End Zones */

/* Start Collection types */
export function getCollectionTypes(onSuccess, onFail) {
  const path = "api/Dealer/getCollectionTypesForAdmin";
  getResource(path, onSuccess, onFail);
}
/* End Collection types */

/* Start refund Apis */
export function refundRedeemedOrder(data, onSuccess, onFail) {
  const path = `api/Dealer/RefundOrder?language=en`;
  postResource(path, data, onSuccess, onFail);
}
export function refundRedeemedProduct(data, onSuccess, onFail) {
  const path = `api/Dealer/RefundItem?language=en`;
  postResource(path, data, onSuccess, onFail);
}
export function refundRedeemedPoints(requestId, onSuccess, onFail) {
  const path = `api/Dealer/RefundPoints?requestIdentifierId=${requestId}&language=en`;
  postResource(path, {}, onSuccess, onFail);
}
/* End refund Apis */

/* Start store items */
export function getStoreItems(onSuccess, onFail) {
  const path = "api/GMStore/StoreItemsForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function uploadStoreItemImage(data, onSuccess, onFail) {
  const path = "api/GMStore/AddItemImage?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function deleteItemImage(data, onSuccess, onFail) {
  const path = `api/GMStore/DeleteItemImage?language=en&imagePath=${data.imagePath}&itemId=${data.itemId}`;
  postResource(path, {}, onSuccess, onFail);
}
export function addStoreItem(data, onSuccess, onFail) {
  const path = "api/GMStore/AddStoreItemV2?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editStoreItem(data, onSuccess, onFail) {
  const path = "api/GMStore/EditStoreItemV2?language=en";
  putResource(path, data, onSuccess, onFail);
}
export const deleteStoreItem = (itemId, onSuccess, onFail) => {
  const path = `api/GMStore/StoreItem?language=en&itemId=${itemId}`;
  deleteResource(path, onSuccess, onFail);
};
export function getStoreOrders(onSuccess, onFail) {
  const path = "api/GMStore/StoreOrders?language=en";
  getResource(path, onSuccess, onFail);
}
export function submitStoreExchangeDelivery(orderId, onSuccess, onFail) {
  const path = `api/GMStore/SubmitStoreExchangeDelivery?storeExchangeId=${orderId}&language=en`;
  postResource(path, {}, onSuccess, onFail);
}
export function changeStatusOfStoreItemsList(data, onSuccess, onFail) {
  const path = `api/GMStore/ActivateOrDeatcivateStoreItemList?language=en`;
  putResource(path, data, onSuccess, onFail);
}
/* End store items */

/* Start store categories */
export function getStoreCategories(onSuccess, onFail) {
  const path = "api/Category/StoreItemcategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveStoreCategories(onSuccess, onFail) {
  const path = "api/Category/StoreItemActiveCategoriesForList?language=en";
  getResource(path, onSuccess, onFail);
}
export function addStoreCategory(data, onSuccess, onFail) {
  const path = "api/Category/AddStoreItemCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editStoreCategory(data, onSuccess, onFail) {
  const path = "api/Category/EditStoreItemCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}
export const deleteStoreCategory = (categoryId, onSuccess, onFail) => {
  const path = `api/Category/DeleteStoreItemCategory?language=en&id=${categoryId}`;
  deleteResource(path, onSuccess, onFail);
};
/* End store categories */

/* Start store subcategories */
export function getStoreSubcategories(onSuccess, onFail) {
  const path = "api/SubCategory/StoreItemSubCategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveStoreSubcategories(categoryId, onSuccess, onFail) {
  const path = `api/SubCategory/GetActiveSubCategoryByCategoryId?language=en&CategoryId=${categoryId}`;
  getResource(path, onSuccess, onFail);
}
export function addStoreSubcategory(data, onSuccess, onFail) {
  const path = "api/SubCategory/AddStoreItemSubCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editStoreSubcategory(data, onSuccess, onFail) {
  const path = "api/SubCategory/EditStoreItemSubCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function deleteStoreSubcategory(subcategoryId, onSuccess, onFail) {
  const path = `api/SubCategory/DeleteStoreItemSubCategory?language=en&id=${subcategoryId}`;
  deleteResource(path, onSuccess, onFail);
}
export function makeCategoryAsSubCategoryOfAnotherCategory(
  data,
  onSuccess,
  onFail,
) {
  const path =
    "api/Category/MaleCategoryAsSubCategoryOfAnotherCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End store subcategories */

/* start of Gulf category */
export function getGetGulfCategoriesForAdmin(onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetGulfCategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function addGulfStoreCategory(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/AddGulfStoreCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editGulfStoreCategory(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/EditGulfStoreCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* end of Gulf category */

/* start of Gulf SubCategories */

export function getGulfStoreSubCategoriesForAdmin(onSuccess, onFail) {
  const path =
    "api/MerchantGulfStore/GetGulfStoreSubCategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function GetActiveGulfCategories(onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetActiveCategories?language=en";
  getResource(path, onSuccess, onFail);
}

export function addGulfStoreSubCategory(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/AddGulfStoreSubCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editGulfStoreSubCategory(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/EditGulfStorSubCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}

/* end of Gulf SubCategories */

/* start of Gulf Products */

export function getGulfProductsForAdmin(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetProductsForAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getActiveSubCategoryByCategoryId(
  CategoryId,
  onSuccess,
  onFail,
) {
  const path = `api/MerchantGulfStore/GetActiveSubCategoryByCategoryId?CategoryId=${CategoryId}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function addProduct(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/AddProduct?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editProduct(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/EditProduct?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* end of Gulf Products */

/* start of Gulf Government */

export function getGulfGovermentForList(onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetGovenmentForList?language=en";
  getResource(path, onSuccess, onFail);
}
export function getGulfGovermentForAdmin(onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetGovermentForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function addGulfGovernment(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/AddGovernment?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editGulfGovernment(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/EditGovernment?language=en";
  putResource(path, data, onSuccess, onFail);
}

/* end of Gulf Government */

/* start of Gulf District */

export function getGulfDistrictForAdmin(onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetDistrictForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function addGulfDistrict(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/AddDistrict?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editGulfDistrict(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/EditDistrict?language=en";
  putResource(path, data, onSuccess, onFail);
}

/* end of Gulf District */

/* Start Do don't images */
export function getDoDontImages(onSuccess, onFail) {
  const path = "api/Cart/GetSupplyCartExampleForAdmin";
  getResource(path, onSuccess, onFail);
}
export function addDoDontImage(data, onSuccess, onFail) {
  const path = "api/Cart/AddSupplyCartExample";
  postResource(path, data, onSuccess, onFail);
}
export function updateDoDontImage(data, onSuccess, onFail) {
  const path = "api/Cart/EditSupplyCartExample";
  putResource(path, data, onSuccess, onFail);
}
export function deleteDoDontImage(id, onSuccess, onFail) {
  const path = `api/Cart/DeleteSupplyCartExample?id=${id}`;
  deleteResource(path, onSuccess, onFail);
}
/* End Do don't images */

/* Start Home banners */
export function getHomeBanners(onSuccess, onFail) {
  const path = "api/Banner/HomeBannerForAdmin";
  getResource(path, onSuccess, onFail);
}
export function addHomeBanner(data, onSuccess, onFail) {
  const path = "api/Banner/AddHomeBanner";
  postResource(path, data, onSuccess, onFail);
}
export function updateHomeBanner(data, onSuccess, onFail) {
  const path = "api/Banner/EditHomeBanner";
  putResource(path, data, onSuccess, onFail);
}
export function deleteHomeBanner(id, onSuccess, onFail) {
  const path = `api/Banner/DeleteHomeBanner?id=${id}`;
  deleteResource(path, onSuccess, onFail);
}
/* End Home banners */

/* Start Notification */
export function sendNotification(data, onSuccess, onFail) {
  const path = "api/Notification/SendNotificationToAllScrappers";
  postResource(path, data, onSuccess, onFail);
}
/* End Notification */

/* Start Partners */
export function getPartners(data, onSuccess, onFail) {
  const path = "api/Partner/GetPartnersForAdminV2?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getAllPartnersWithoutPagination(onSuccess, onFail) {
  const path = "api/Partner/GetPartnersForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function addPartner(data, onSuccess, onFail) {
  const path = "api/Partner?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editPartner(data, onSuccess, onFail) {
  const path = "api/Partner/EditStoreItemCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function getPartnersOfCategoryForList(categoryId, onSuccess, onFail) {
  const path = `api/Partner/PartnerCategoryForList?language=en&categoryId=${categoryId}`;
  getResource(path, onSuccess, onFail);
}

export function getPartnersOfSubcategoryForList(
  subcategoryId,
  onSuccess,
  onFail,
) {
  const path = `api/Partner/PartnerSubCategoryForList?language=en&subcategoryId=${subcategoryId}`;
  getResource(path, onSuccess, onFail);
}

export function getPartnersForList(onSuccess, onFail) {
  const path = "api/Partner/PartnerForList?language=en";
  getResource(path, onSuccess, onFail);
}
/* End Partners */

/* Start Partnership */
export function getPartnership(onSuccess, onFail) {
  const path = "api/PartnerShip/ForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function addPartnership(data, onSuccess, onFail) {
  const path = "api/PartnerShip?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editPartnership(data, onSuccess, onFail) {
  const path = "api/PartnerShip?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function sendCourierToPartnership(data, onSuccess, onFail) {
  const path = "api/PartnerShip/AssignCourierToPartnerShip?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Partnership */

/* Start Sales Requests Returns */
export function getMerchants(onSuccess, onFail) {
  const path = "api/Dealer/GetMerchants?language=en";
  getResource(path, onSuccess, onFail);
}

export function getSalesRequestsReturns(onSuccess, onFail) {
  const path = "api/Dealer/GetSalesRequestReturns?language=en";
  getResource(path, onSuccess, onFail);
}

export function addSalesRequestsReturn(data, onSuccess, onFail) {
  const path = "api/Dealer/SaleRequestReturns?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getCategoriesForList(onSuccess, onFail) {
  getResource(
    withParams("api/ScrapperSupplyType/GetSupplyTypesForList"),
    onSuccess,
    onFail,
  );
}

export function deleteSalesRequestsReturn(requestId, onSuccess, onFail) {
  const path = `api/Dealer/SaleRequestReturns?id=${requestId}&language=en`;
  deleteResource(path, onSuccess, onFail);
}
/* End Sales Requests Returns */

/* Start Merchant Periods */
export function getMerchantPeriods(onSuccess, onFail) {
  const path =
    "api/ScrapperSupplyType/GetMerchantReceivingPeriodForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function getMerchantPeriodsForList(onSuccess, onFail) {
  const path =
    "api/ScrapperSupplyType/GetMerchantReceivingPeriodForList?language=en";
  getResource(path, onSuccess, onFail);
}

export function addMerchantPeriods(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType/AddMerchantReceivingPeriod?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editMerchantPeriods(data, onSuccess, onFail) {
  const path = "api/ScrapperSupplyType/EditMerchantReceivingPeriod?language=en";
  putResource(path, data, onSuccess, onFail);
}
/* End Merchant Periods */

/* Start Merchant Scrap Types */
export function getMerchantScrapTypes(onSuccess, onFail) {
  const path =
    "api/ScrapperSupplyType/GetScrraperSuppliesTypeMerchantPricesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function addMerchantScrapTypesPriceList(data, onSuccess, onFail) {
  const path =
    "api/ScrapperSupplyType/AddMerchantScrapperTypePrices?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Merchant Scrap Types */

/* Start Districts */
export function getCourierDistricts(onSuccess, onFail) {
  const path = "api/District/CourierDistrictForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function getCourierDistrictsForList(govenmentId, onSuccess, onFail) {
  const path = `api/District/CourierDistrictsForList?govenmentId=${govenmentId}&language=en`;
  getResource(path, onSuccess, onFail);
}

export function addCourierDistrict(data, onSuccess, onFail) {
  const path = "api/District/CourierDistrict?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function editCourierDistrict(data, onSuccess, onFail) {
  const path = "api/District/CourierDistrict?language=en";
  putResource(path, data, onSuccess, onFail);
}

export function deleteCourierDistrict(id, onSuccess, onFail) {
  const path = `api/District/CourierDistrict?language=en&id=${id}`;
  deleteResource(path, onSuccess, onFail);
}

export function assignCourierToDistrict(data, onSuccess, onFail) {
  const path = "api/Courier/AssignCourierDistrict?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Districts */

/* Start community categories */
export function getCommunityCategories(onSuccess, onFail) {
  const path = "api/Scout/GetWallCategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveCommunityCategories(onSuccess, onFail) {
  const path = "api/Scout/GetActiveWallCategories?language=en";
  getResource(path, onSuccess, onFail);
}
export function addCommunityCategory(data, onSuccess, onFail) {
  const path = "api/Scout/AddWallCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editCommunityCategory(data, onSuccess, onFail) {
  const path = "api/Scout/EditWallCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}
export const deleteCommunityCategory = (categoryId, onSuccess, onFail) => {
  const path = `api/Scout/DeleteWallCategory?language=en&id=${categoryId}`;
  deleteResource(path, onSuccess, onFail);
};
/* End community categories */

/* Start community subcategories */
export function getCommunitySubcategories(onSuccess, onFail) {
  const path = "api/Scout/GetWallSubCategoriesForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveCommunitySubCategories(onSuccess, onFail) {
  const path = "api/Scout/GetActiveWallSubCategories?language=en";
  getResource(path, onSuccess, onFail);
}
export function getActiveCommunitySubCategoriesByCategoryId(
  categoryId,
  onSuccess,
  onFail,
) {
  const path = `api/Scout/GetActiveSubCategoriesByCategoryId?categoryId=${categoryId}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function addCommunitySubcategory(data, onSuccess, onFail) {
  const path = "api/Scout/AddWallSubCategory?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function editCommunitySubcategory(data, onSuccess, onFail) {
  const path = "api/Scout/EditWallSubCategory?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function deleteCommunitySubcategory(subcategoryId, onSuccess, onFail) {
  const path = `api/Scout/DeleteWallSubCategory?language=en&id=${subcategoryId}`;
  deleteResource(path, onSuccess, onFail);
}
/* End community subcategories */

/* Start Pending Posts */
export function getAcceptedPosts(data, onSuccess, onFail) {
  const path = "api/Scout/AllPostsForAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getAllPendingPosts(data, onSuccess, onFail) {
  const path = "api/Scout/AllPendingPostsForAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getAllRejectedPosts(data, onSuccess, onFail) {
  const path = "api/Scout/AllRejectedPostsForAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function activateOrDeactivatePost(data, onSuccess, onFail) {
  const path = "api/Scout/ActivateOrDeativatePost?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function editPostByAdmin(data, onSuccess, onFail) {
  const path = "api/Scout/EditPostByAdmin?language=en";
  putResource(path, data, onSuccess, onFail);
}
export function deletePost(postId, onSuccess, onFail) {
  const path = `api/Scout/DeletePostByAdmin?id=${postId}&language=en`;
  deleteResource(path, onSuccess, onFail);
}
export function activeWallCategories(onSuccess, onFail) {
  const path = `api/Scout/GetActiveWallCategories?language=en`;
  getResource(path, onSuccess, onFail);
}
export function activeWallSubCategories(categoryId, onSuccess, onFail) {
  const path = `api/Scout/GetActiveSubCategoriesByCategoryId?categoryId=${categoryId}&language=en`;
  getResource(path, onSuccess, onFail);
}
/* Start Pending Posts */

/* Start Cash Transfer */
export function getCashTransferData(data, onSuccess, onFail) {
  const path =
    "api/Dealer/ScrapperCansHistoryWithMultipleTypesForAdminV2ForCash?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function addCashTransferReceipt(data, onSuccess, onFail) {
  const path = "api/Dealer/AddCashTransferReceipt?language=en";
  postResource(path, data, onSuccess, onFail);
}
/* End Cash Transfer */

/* Start Admin Posts */
export function getAdminPosts(onSuccess, onFail) {
  const path = "api/Scout/GetAdminPost?language=en";
  getResource(path, onSuccess, onFail);
}
/* End Admin Posts */

/* Start Installment Plans */
export function getInstallmentPlans(onSuccess, onFail) {
  const path = "api/InstallmentPlan/AllInstallmentPlans?language=en";
  getResource(path, onSuccess, onFail);
}
export function addInstallmentPlans(payload, onSuccess, onFail) {
  const path = "api/InstallmentPlan/AddInstallmentPlan?language=en";
  postResource(path, payload, onSuccess, onFail);
}
export function editInstallmentPlans(payload, onSuccess, onFail) {
  const path = "api/InstallmentPlan/EditInstallmentPlan?language=en";
  putResource(path, payload, onSuccess, onFail);
}
export function deleteInstallmentPlan(planId, onSuccess, onFail) {
  const path = `api/InstallmentPlan/DeleteInstallmentPlan?language=en&InstallmentPlanId=${planId}`;
  deleteResource(path, onSuccess, onFail);
}
/* End Installment Plans */

/* Start Installment Requests */
export function getInstallmentRequests(onSuccess, onFail) {
  const path = "api/InstallmentPlan/GetInstallmentApplications?language=en";
  getResource(path, onSuccess, onFail);
}
export function acceptOrRejectInstallmentRequests(payload, onSuccess, onFail) {
  const path =
    "api/InstallmentPlan/AddInstallmentApplicationResult?language=en";
  postResource(path, payload, onSuccess, onFail);
}
/* End Installment Requests */

/* Start Installment Pending Orders */
export function getInstallmentPendingOrders(onSuccess, onFail) {
  const path = `api/InstallmentPlan/GetAllPendingOrderForDashboard?language=en&pageNumber=1`;
  getResource(path, onSuccess, onFail);
}
export function acceptOrRejectInstallmentPendingOrder(
  payload,
  onSuccess,
  onFail,
) {
  const path = "api/InstallmentPlan/AcceptOrRejectPendingOrder?language=en";
  postResource(path, payload, onSuccess, onFail);
}
/* End Installment Pending Orders */

/* Start Customer Payment Dues */
export function getCustomerPaymentDues(onSuccess, onFail) {
  const path =
    "api/InstallmentPlan/GetAggregatedMonthlyInstallmentsForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
/* End Customer Payment Dues */

// const isStockAdmin = store.getState()?.auth?.authorization?.roles?.[0] === 20;

// /* Start stock merchant */
// export function getStockMerchants(onSuccess, onFail) {
//   const path = `api/Stock/GetStockMerchants?language=${
//     isStockAdmin ? "ar" : "en"
//   }`;
//   getResource(path, onSuccess, onFail);
// }

// export function getActiveStockMerchants(onSuccess, onFail) {
//   const path = "api/Stock/GetActiveMerchants?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function getShopStores(onSuccess, onFail) {
//   const path = "api/Admin/GetShopStores?language=ar";
//   getResource(path, onSuccess, onFail);
// }

// export function addStockMerchant(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddStockMerchant?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }

// export function editStockMerchant(payload, onSuccess, onFail) {
//   const path = "api/Stock/EditStockMerchant?language=en";
//   putResource(path, payload, onSuccess, onFail);
// }

// export function deleteStockMerchant(merchantId, onSuccess, onFail) {
//   const path = `api/Stock/DeleteStockMerchant?id=${merchantId}&language=en`;
//   deleteResource(path, onSuccess, onFail);
// }

// /* End stock merchant */

// /* Start stock buyers */
// export function getStockBuyers(onSuccess, onFail) {
//   const path = "api/Stock/GetStockPurchaseUsers?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function getActiveStockBuyers(onSuccess, onFail) {
//   const path = "api/Stock/GetActivePurchaseUsers?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function addStockBuyer(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddStockPurchaseUser?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }

// export function editStockBuyer(payload, onSuccess, onFail) {
//   const path = "api/Stock/EditStockPurchaseUser?language=en";
//   putResource(path, payload, onSuccess, onFail);
// }

// export function deleteStockBuyer(buyerId, onSuccess, onFail) {
//   const path = `api/Stock/DeleteStockPurchaseUser?id=${buyerId}&language=en`;
//   deleteResource(path, onSuccess, onFail);
// }
// /* End stock buyers */

// /* Start stock merchant order */
// export function getStockMerchantsOrders(onSuccess, onFail) {
//   const path = "api/Stock/GetStockMerchantOrder?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function addStockMerchantOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddStockMerchantOrder?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }

// export function editStockMerchantOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/EditStockMerchantOrder?language=en";
//   putResource(path, payload, onSuccess, onFail);
// }

// export function deleteStockMerchantOrder(id, onSuccess, onFail) {
//   const path = `api/Stock/DeleteStockMerchantOrder?id=${id}&language=en`;
//   deleteResource(path, onSuccess, onFail);
// }
// /* End stock merchant order */

// /* Start stock buyer order */
// export function getStockBuyersOrders(onSuccess, onFail) {
//   const path = "api/Stock/GetStockPurchaseUserOrder?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function addStockBuyerOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddStockPurchaseUserOrder?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }

// export function editStockBuyerOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/EditStockPurchaseUserOrder?language=en";
//   putResource(path, payload, onSuccess, onFail);
// }

// export function deleteStockBuyerOrder(id, onSuccess, onFail) {
//   const path = `api/Stock/DeleteStockPurchaseUserOrder?id=${id}&language=en`;
//   deleteResource(path, onSuccess, onFail);
// }
// /* End stock buyer order */

// /* Start stock daily couriers */
// export function getStockDailyCouriers(onSuccess, onFail) {
//   const path = "api/Stock/GetTodayCourierOrders?language=en";
//   getResource(path, onSuccess, onFail);
// }
// export function getAllStockOrders(onSuccess, onFail) {
//   const path = "api/Stock/GetCourierOrders?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function addCourierActualOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddCourierActualOrder?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }
// export function editCourierActualOrder(payload, onSuccess, onFail) {
//   const path = "api/Stock/EditCourierActualOrder?language=en";
//   putResource(path, payload, onSuccess, onFail);
// }
// /* End stock daily couriers */

// /* Start stock scrap types */
// export function getStockScrapTypes(onSuccess, onFail) {
//   const path = "api/Stock/GetStockBalance?language=en";
//   getResource(path, onSuccess, onFail);
// }
// /* End stock scrap types */

// const isStockAdmin = store.getState()?.auth?.authorization?.roles?.[0] === 20;
// const lang = isStockAdmin ? "ar" : "en";

/* Start stock merchant */
export function getStockMerchants(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetStockMerchants"), onSuccess, onFail);
}

export function getActiveStockMerchants(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetActiveMerchants"), onSuccess, onFail);
}

export function getShopStores(onSuccess, onFail) {
  getResource(withParams("api/Admin/GetShopStores"), onSuccess, onFail);
}

export function addStockMerchant(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddStockMerchant"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function editStockMerchant(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  putResource(
    withParams("api/Stock/EditStockMerchant"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function deleteStockMerchant(merchantId, onSuccess, onFail) {
  deleteResource(
    withParams(`api/Stock/DeleteStockMerchant?id=${merchantId}`),
    onSuccess,
    onFail,
  );
}
/* End stock merchant */

/* Start stock buyers */
export function getStockBuyers(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetStockPurchaseUsers"), onSuccess, onFail);
}

export function getActiveStockBuyers(onSuccess, onFail) {
  getResource(
    withParams("api/Stock/GetActivePurchaseUsers"),
    onSuccess,
    onFail,
  );
}

export function addStockBuyer(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddStockPurchaseUser"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function editStockBuyer(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  putResource(
    withParams("api/Stock/EditStockPurchaseUser"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function deleteStockBuyer(buyerId, onSuccess, onFail) {
  deleteResource(
    withParams(`api/Stock/DeleteStockPurchaseUser?id=${buyerId}`),
    onSuccess,
    onFail,
  );
}
/* End stock buyers */

/* Start stock merchant order */
export function getStockMerchantsOrders(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetStockMerchantOrder"), onSuccess, onFail);
}

export function addStockMerchantOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddStockMerchantOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function editStockMerchantOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  putResource(
    withParams("api/Stock/EditStockMerchantOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function deleteStockMerchantOrder(id, onSuccess, onFail) {
  deleteResource(
    withParams(`api/Stock/DeleteStockMerchantOrder?id=${id}`),
    onSuccess,
    onFail,
  );
}
/* End stock merchant order */

/* Start stock buyer order */
export function getStockBuyersOrders(onSuccess, onFail) {
  getResource(
    withParams("api/Stock/GetStockPurchaseUserOrder"),
    onSuccess,
    onFail,
  );
}

export function addStockBuyerOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddStockPurchaseUserOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function editStockBuyerOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  putResource(
    withParams("api/Stock/EditStockPurchaseUserOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function deleteStockBuyerOrder(id, onSuccess, onFail) {
  deleteResource(
    withParams(`api/Stock/DeleteStockPurchaseUserOrder?id=${id}`),
    onSuccess,
    onFail,
  );
}
/* End stock buyer order */

/* Start stock daily couriers */
export function getStockDailyCouriers(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetTodayCourierOrders"), onSuccess, onFail);
}

export function getAllStockOrders(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetCourierOrders"), onSuccess, onFail);
}

export function addCourierActualOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddCourierActualOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}

export function editCourierActualOrder(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  putResource(
    withParams("api/Stock/EditCourierActualOrder"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}
/* End stock daily couriers */

/* Start stock scrap types */
export function getStockScrapTypes(onSuccess, onFail) {
  getResource(withParams("api/Stock/GetStockBalance"), onSuccess, onFail);
}
/* End stock scrap types */

/* Start post attributes */
export function getPostAttributes(onSuccess, onFail) {
  const path = "api/PostAttribute/GetPostAttributeForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function addPostAttributes(payload, onSuccess, onFail) {
  const path = "api/PostAttribute/AddPostAttribute?language=en";
  postResource(path, payload, onSuccess, onFail);
}

export function editPostAttributes(payload, onSuccess, onFail) {
  const path = "api/PostAttribute/EditPostAttribute?language=en";
  putResource(path, payload, onSuccess, onFail);
}

export function getControllerTypes(onSuccess, onFail) {
  const path = "api/PostAttribute/GetControllerTypes?language=en";
  getResource(path, onSuccess, onFail);
}

export function getAttributeKeys(onSuccess, onFail) {
  const path = "api/PostAttribute/GetPostAttributeKeysForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function getActiveAttributeKeys(onSuccess, onFail) {
  const path = "api/PostAttribute/GetActiveKeys?language=en";
  getResource(path, onSuccess, onFail);
}

export function addAttributesKey(payload, onSuccess, onFail) {
  const path = "api/PostAttribute/AddPostAttributeKey?language=en";
  postResource(path, payload, onSuccess, onFail);
}
export function editAttributesKey(payload, onSuccess, onFail) {
  const path = "api/PostAttribute/EditPostAttributeKey?language=en";
  putResource(path, payload, onSuccess, onFail);
}
/* End post attributes */

/* Start track courier location */
export function getCourierLocations(onSuccess, onFail) {
  const path = "api/Courier/GetCourierLocations?language=en";
  getResource(path, onSuccess, onFail);
}
/* End track courier location */

// /* Start Initial Scrap Balance */
// export function getInitialScrapBalance(onSuccess, onFail) {
//   const path = "api/Stock/GetScrapTypeStartOfPeriod?language=en";
//   getResource(path, onSuccess, onFail);
// }

// export function addInitialScrapBalance(payload, onSuccess, onFail) {
//   const path = "api/Stock/AddStartOfPeriodScrapTypeBalance?language=en";
//   postResource(path, payload, onSuccess, onFail);
// }
// /* End Initial Scrap Balance */

/* Start Initial Scrap Balance */
export function getInitialScrapBalance(onSuccess, onFail) {
  getResource(
    withParams("api/Stock/GetScrapTypeStartOfPeriod"),
    onSuccess,
    onFail,
  );
}

export function addInitialScrapBalance(payload, onSuccess, onFail) {
  const state = store.getState();
  const storeId = state?.shop?.selectedShop;
  const updatedPayload = storeId ? { ...payload, storeId } : { ...payload };

  postResource(
    withParams("api/Stock/AddStartOfPeriodScrapTypeBalance"),
    updatedPayload,
    onSuccess,
    onFail,
  );
}
/* End Initial Scrap Balance */

export function uploadVideo(payload, onSuccess, onFail) {
  const path = "api/GMStore/AddVideo";
  postResource(path, payload, onSuccess, onFail);
}

export function uploadImage(payload, onSuccess, onFail) {
  const path = "api/GMStore/AddItemImage";
  postResource(path, payload, onSuccess, onFail);
}

export function getSalesRequestVideos(id, onSuccess, onFail) {
  const path = `api/Dealer/GetSalesRequestVideos?requestId=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}
export function GetAllFilteredSalesRequestVideos(data, onSuccess, onFail) {
  const path = `api/Dealer/GetAllFilteredSalesRequestVideos?language=en`;
  postResource(path, data, onSuccess, onFail);
}

// Ratings
export function getDealerRates(onSuccess, onFail) {
  const path = `api/Admin/GetDealerRates?language=en`;
  getResource(path, onSuccess, onFail);
}

// Courier Weights
export function getCourierWeight(payload = {}, onSuccess, onFail) {
  const params = new URLSearchParams({ language: "en" });
  if (payload.from) {
    params.append("from", payload.from);
  }
  if (payload.to) {
    params.append("to", payload.to);
  }
  const path = `api/Courier/GetCourierOrdersSummary?${params.toString()}`;
  getResource(path, onSuccess, onFail);
}

// Courier Weights
export function getCountriesForAdmin(onSuccess, onFail) {
  const path = `api/ScrapperSupplyType/GetCountriesForAdmin?language=en`;
  getResource(path, onSuccess, onFail);
}

// start of qusetions and categories
export function getAllPlayAndWinLanguage(onSuccess, onFail) {
  const path = `api/PlayAndWinLanguage/getLanguages?language=en`;
  getResource(path, onSuccess, onFail);
}

export function getAllQuestionsCategory(onSuccess, onFail) {
  const path = `api/QuestionsCategory/GetCategoriesForAdmin?language=en`;
  getResource(path, onSuccess, onFail);
}

export function editQuestionsCategory(data, onSuccess, onFail) {
  const path = `api/QuestionsCategory/EditCategory?language=en`;
  putResource(path, data, onSuccess, onFail);
}

export function addQuestionsCategory(data, onSuccess, onFail) {
  const path = `api/QuestionsCategory/AddCategory?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function getAllQuestions(onSuccess, onFail) {
  const path = `api/Question/getAll`;
  getResource(path, onSuccess, onFail);
}

export function getSingleQuestion(onSuccess, onFail) {
  const path = `api/Question/GetQuestion`;
  getResource(path, onSuccess, onFail);
}

export function addNewQuestion(data, onSuccess, onFail) {
  const path = `api/Question/add`;
  postResource(path, data, onSuccess, onFail);
}

export function editQuestion(data, onSuccess, onFail) {
  const path = `api/Question/edit`;
  putResource(path, data, onSuccess, onFail);
}

//apis for merchant screens

export function GetBuyAndSupplyBuyItemsForScraptionForAdmin(onSuccess, onFail) {
  const path = `api/Item/GetBuyAndSupplyBuyItemsForScraptionForAdmin?language=en`;
  getResource(path, onSuccess, onFail);
}

export function AddBuyAndSupplyBuyItemForScraption(data, onSuccess, onFail) {
  const path = `api/Item/AddBuyAndSupplyBuyItemForScraption?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function EditBuyAndSupplyBuyItemForScraption(data, onSuccess, onFail) {
  const path = `api/Item/EditBuyAndSupplyBuyItemForScraption?language=en`;
  putResource(path, data, onSuccess, onFail);
}

export const DeleteBuyAndSupplyBuyItemForScraption = (
  { itemId },
  onSuccess,
  onFail,
) => {
  const path = `api/Item/DeleteBuyAndSupplyBuyItemForScraption?itemId=${itemId}&language=en`;
  deleteResource(path, onSuccess, onFail);
};

export function GetPendingOrdersForScraptionForAdmin(onSuccess, onFail) {
  const path = `api/BuyAndSupply/GetPendingOrdersForScraptionForAdmin?language=en`;
  getResource(path, onSuccess, onFail);
}

export function AcceptOrRejectPendingOrderForScraptionByAdmin(
  data,
  onSuccess,
  onFail,
) {
  const path = `api/BuyAndSupply/AcceptOrRejectPendingOrderForScraptionByAdmin?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function GetOrdersForScraptionForAdmin(data, onSuccess, onFail) {
  const path = `api/BuyAndSupply/GetOrdersForScraptionForAdmin?language=en`;
  postResource(path, data, onSuccess, onFail);
}

// scraption company

export function GetAllScraptionCompany(onSuccess, onFail) {
  const path = `api/ScraptionCompany?language=en`;
  getResource(path, onSuccess, onFail);
}

export function AddScraptionCompany(data, onSuccess, onFail) {
  const path = `api/ScraptionCompany?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function EditScraptionCompany(data, onSuccess, onFail) {
  const path = `api/ScraptionCompany?language=en`;
  putResource(path, data, onSuccess, onFail);
}

export function getStoreOrdersForAdmin(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/GetStoreOrdersForAdmin?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function merchantrefundOrder(data, onSuccess, onFail) {
  const path = `api/MerchantGulfStore/RefundOrder?language=en`;
  postResource(path, data, onSuccess, onFail);
}

export function changeMerchantOrderStatus(data, onSuccess, onFail) {
  const path = "api/MerchantGulfStore/ChangeOrderStatus?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function getCashCollectionFromWalletForAdmin(onSuccess, onFail) {
  const path =
    "api/MerchantGulfStore/GetCashCollectionFromWalletForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}
export function getAcceptedCashCollectionFromWalletForAdmin(onSuccess, onFail) {
  const path =
    "api/MerchantGulfStore/GetAcceptedCashCollectionFromWalletForAdmin?language=en";
  getResource(path, onSuccess, onFail);
}

export function approveCashCollectionFromWallet(data, onSuccess, onFail) {
  const path =
    "api/MerchantGulfStore/ApproveCashCollectionFromWallet?language=en";
  postResource(path, data, onSuccess, onFail);
}
export function getWalletlogs(id, onSuccess, onFail) {
  const path = `api/MerchantGulfStore/GetWalletLogs?id=${id}&language=en`;
  getResource(path, onSuccess, onFail);
}

//merchant national id

export function GetMerchantAddNationalId(onSuccess, onFail) {
  const path = "api/Dealer/GetMerchantAddNationalIdRequest?language=en";
  getResource(path, onSuccess, onFail);
}

export function AcceptOrRejectNationalId(data, onSuccess, onFail) {
  const path = "api/Dealer/AcceptOrRejectNationalId?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function StorePolygons(data, onSuccess, onFail) {
  const path = "api/admin/StorePolygns?language=en";
  postResource(path, data, onSuccess, onFail);
}

export function GetDealerOrdersStatisticsByAdmin(onSuccess, onFail) {
  const path = `api/Admin/GetDealerOrdersStatistics?language=en`;
  getResource(path, onSuccess, onFail);
}
